import { render, staticRenderFns } from "./TalentStrategy.vue?vue&type=template&id=f2d1316a&scoped=true&"
import script from "./TalentStrategy.vue?vue&type=script&lang=js&"
export * from "./TalentStrategy.vue?vue&type=script&lang=js&"
import style0 from "./TalentStrategy.vue?vue&type=style&index=0&id=f2d1316a&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f2d1316a",
  null
  
)

export default component.exports